import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Injectable()
export class UserFormService {
  form = this.createForm();

  reset() {
    this.form = this.createForm();
  }

  private createForm() {
    return new FormGroup({
      first_name: new FormControl<string>('', {
        nonNullable: true,
        validators: [Validators.required],
      }),
      last_name: new FormControl<string>('', {
        nonNullable: true,
        validators: [Validators.required],
      }),
      email: new FormControl<string>('', {
        nonNullable: true,
        validators: [Validators.required, Validators.email],
      }),
      role: new FormControl<string>('', { nonNullable: true, validators: [Validators.required] }),
      companyIdList: new FormControl<number[]>([], { nonNullable: true }),
      sqlQueryAccess: new FormControl<boolean>(false, { nonNullable: true }),
    });
  }
}
